import useMultiSongStore from "../store/multiSongStore";
import useSongWriterAssignmentStore from "../store/songWriterAssignmentStore";
import useWriterStore from "../store/writerStore";

export type ValidationResult = {
  isValid: boolean;
  errorMessage: string;
  songsWithoutWriters: Array<{ id: string; name: string }>;
};

export function validateAllSongsHaveWriters(): ValidationResult {
  const multiSongStore = useMultiSongStore.getState();
  const writerStore = useWriterStore.getState();
  const assignmentStore = useSongWriterAssignmentStore.getState();

  // Filter out recordings and variants - they inherit writers from parent work
  const selectedTracks = multiSongStore.tracks.filter((track) => {
    if (!track.isSelected)
      return false;

    // Exclude recordings (tracks confirmed to attach to existing account work)
    const isRecording = track.isSuspectedDuplicate === true && track.reviewAction !== "dismiss";
    if (isRecording)
      return false;

    // Exclude variants (tracks that are variants of another album track)
    const isVariant = typeof track.suspectedAlbumTrackId === "string" && track.suspectedAlbumTrackId.length > 0 && track.reviewAction !== "dismiss";
    if (isVariant)
      return false;

    return true;
  });
  const selectedWriters = writerStore.selectedWriters;
  const assignments = assignmentStore.assignments;

  if (selectedTracks.length === 0 || selectedWriters.length === 0) {
    return {
      isValid: false,
      errorMessage: "No songs or writers selected.",
      songsWithoutWriters: [],
    };
  }

  const songsWithoutWriters = selectedTracks.filter((track) => {
    const songAssignments = assignments[track.id];
    if (typeof songAssignments === "undefined") {
      return true; // No assignments for this song
    }
    return selectedWriters.every(writer => !songAssignments[writer.writercode]);
  });

  const songsWithoutWritersCount = songsWithoutWriters.length;

  return {
    isValid: songsWithoutWritersCount === 0,
    errorMessage: songsWithoutWritersCount > 0
      ? `${songsWithoutWritersCount} song${songsWithoutWritersCount === 1 ? "" : "s"} still need${songsWithoutWritersCount === 1 ? "s" : ""} at least one writer assigned: ${songsWithoutWriters.slice(0, 3).map(s => s.name).join(", ")}${songsWithoutWritersCount > 3 ? ` and ${songsWithoutWritersCount - 3} more` : ""}`
      : "",
    songsWithoutWriters: songsWithoutWriters.map(s => ({ id: s.id, name: s.name })),
  };
}
